<template>
  <div>
    <div class="banner innerpageBanner"><div class="container"><div class="caption"><div>
      <h1>常见问题</h1>
      <p>回答您有关网站和订阅的疑问</p>
    </div></div></div>
      <img src="https://image.insideburgundy.cn/insideburgundy/20190525/4c72c2644ce94ee3bb22465b0cb2e334.png" class="cover-image"></div>

    <div class="container">
      <searchBox/>
      <div class="breadcrumbWrap">
        <div class="breadcrumb" style="padding-top:20px">
          <span property="itemListElement" typeof="ListItem">
            <a
              property="item"
              typeof="WebPage"
              title="Go to Jasper Morris Inside Burgundy."
              href="#/"
              class="home"
            >
              <span property="name">首页</span>
            </a>
            <meta property="position" content="1">
          </span> /
          <span property="itemListElement" typeof="ListItem">
            <span property="name">FAQS</span>
            <meta property="position" content="2">
          </span>
        </div>
      </div>
    </div>
    <section class="innerPage">
      <div class="container">
        <div class="rightCol">
          <div class="subpageNav faqCat">
            <h4>
              分类
              <span></span>
            </h4>
            <ul>
              <li>
                <a href="#General-Questions">网站问题</a>
              </li>
              <li>
                <a href="#Account-Questions">账号问题</a>
              </li>
              <li>
                <a href="#Subscription">订阅问题</a>
              </li>
              <li>
                <a href="#Burgundy-Questions">勃艮第问题</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="leftCol">
          <h2>常见问题 FAQs</h2>
          <div class="faqs">
            <h4 id="General-Questions">网站问题</h4>
            <ul>
              <li>
                <div class="faqQustion">我为何无法阅读品鉴报告?</div>
                <div class="faqAns">
                  <p class="p1">
                    <span class="s1">您只有付费成为订阅用户才可查看品鉴报告和全部酒评，订阅请点击网页右侧查询框下方“订阅”按钮，并按提示进行操作。</span>
                  </p>
                </div>
              </li>
              <li>
                <div class="faqQustion">品鉴报告是什么?</div>
                <div class="faqAns">
                  <p class="p1">
                    <span
                      class="s1"
                    >品鉴报告是指Jasper Morris MW及团队对一系列酒款的品鉴纪录，这些酒款可能来自同一年份，同一酒庄，同一村子，同一田块，并具有某一特定主体。</span>
                  </p>
                </div>
              </li>
              <li>
                <div class="faqQustion">酒评是什么？</div>
                <div class="faqAns">
                  <p>酒评是Jasper Morris及团队对某一特定酒款的品鉴纪录。</p>
                </div>
              </li>
              <li>
                <div class="faqQustion">我可以摘抄和引用Inside Burgundy网站上的内容吗？</div>
                <div class="faqAns">
                  <p>网站上一切内容版权归Inside Burgundy公司所有。在说明“本内容来自Jasper Morris Inside Burgundy”网站且不对原文内容做出任何更改的前提下，可引用本网站上出现的品鉴笔记及分数。所有图片均不可复制引用。如您需引用更多内容请与我们取得联系。</p>
                </div>
              </li>
            </ul>
            <h4 id="Account-Questions">账号问题</h4>
            <ul>
              <li>
                <div class="faqQustion">如何登录</div>
                <div class="faqAns">
                  <p class="p1">
                    <span
                      class="s1"
                    >请点击网站右上方“登录”，输入您注册时使用的手机号码或账号名称，输入密码进行登录。</span>
                  </p>
                </div>
              </li>
              <li>
                <div class="faqQustion">如何更改登录手机号码和邮箱？</div>
                <div class="faqAns">
                  <p class="p1">
                    <span
                      class="s1"
                    >在页面上方点击您的用户名，进入账号管理页面，在“我的资料”中进行修改。</span>
                  </p>
                </div>
              </li>
              <li>
                <div class="faqQustion">如何重设密码？</div>
                <div class="faqAns">
                  <p>在网站登录页面点击“<a href="#/Forgetpassword">忘记密码</a>”，输入您的手机号码，一条消息将发送到您注册时绑定的手机号码，您可按照消息提示进行操作。</p>
                </div>
              </li>
            </ul>
            <h4 id="Subscription">订阅问题</h4>
            <ul>
              <li>
                <div class="faqQustion">如何进行订阅？</div>
                <div class="faqAns">
                  <p>点击位于网站上方右侧红色区域的“订阅”按钮，按照提示进行操作。</p>
                </div>
              </li>
              <li>
                <div class="faqQustion">订阅如何收费？</div>
                <div class="faqAns">
                  <p>订阅按年收费，每年的费用为800元人民币。订阅用户将获赠Inside Burgundy特别定制版Riedel勃艮第酒杯一支。</p>
                </div>
              </li>
              <li>
                <div class="faqQustion">订阅临近到期时我是否会收到提醒？</div>
                <div class="faqAns">
                  <p>您在订阅到期前会收到我们发出的到期续费提醒。</p>
                </div>
              </li>
              <li>
                <div
                  class="faqQustion"
                >如何支付我的订阅费用？</div>
                <div class="faqAns">
                  <p>您可通过信用卡、微信、支付宝或银行转账的的方式进行付费。</p>
                </div>
              </li>
              <li>
                <div class="faqQustion">如何注销账户？</div>
                <div class="faqAns">
                  <p>请发邮件至：subscriber@insideburgundy.cn, 我们的工作人员将和您取得联系。</p>
                </div>
              </li>
              <li>
                <div class="faqQustion">如何使用账号在微信中登录并查看酒评？</div>
                <div class="faqAns">
                  <p>
                    请在微信中关注我们的小程序“勃艮第指南”，下方导航栏中点击“我的”，随后选择微信快速登录，输入您注册时使用的手机号码，短信验证并授权后登录。如您使用中国大陆以外手机号码，请去除国家和地区代码，直接填写手机号并验证后登录。
                  </p>
                </div>
              </li>
              <li>
                <div class="faqQustion">如何收取网站订阅赠品？</div>
                <div class="faqAns">
                  <p class="p1">
                    <span
                      class="s1"
                    >注册时请认真填写您在中国大陆地区的收货地址，并确保改地址可被签收。赠品目前暂不支持中国大陆以外地区配送，请您谅解。收货地址可在您登录后出现的个人中心页面，选择“我的资料”进行修改。</span>
                  </p>
                </div>
              </li>
              <li>
                <div class="faqQustion">订阅赠品可否退换？</div>
                <div class="faqAns">
                  <p class="p1">
                    <span
                      class="s1"
                    >除运输中可能出现的破碎问题，您一旦签收则代表已确认赠品包装完好无损，赠品将不被退换。</span>
                  </p>
                </div>
              </li>
            </ul>
            <h4 id="Burgundy-Questions">勃艮第问题</h4>
            <ul>
              <li>
                <div class="faqQustion">勃艮第在哪里？</div>
                <div class="faqAns">
                  <p>勃艮第（英文Burgundy，法文Bourgogne）是位于法国东部的葡萄酒产区，该产区包括：夏布利、夜丘、伯恩丘、沙隆内丘、博若莱这些子产区。</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- Main content area end here -->

    <!-- Subsribe Form section Bottom -->
    <!-- Subsribe Form section Bottom -->

  </div>
</template>
<script>
import searchBox from '../template/search'

export default {
  components:{
    searchBox
  },
	methods: {
    hreftwo() {
      this.$router.push({ path: "./insideburgundy" });
		}
	}}
</script>



// WEBPACK FOOTER //
// src/components/Faqs.vue